import { typeCreatorV2 } from 'redux/utils/common';

// //  [REDUCER][TYPE]
export const SET_STORES_LIST: string = typeCreatorV2(
  'StoreReducer',
  'SetStoresList'
);
export const INSERT_STORES: string = typeCreatorV2(
  'StoreReducer',
  'InsertStore'
);
export const UPDATE_STROES: string = typeCreatorV2(
  'StoreReducer',
  'UpdateStore'
);
export const DELETE_STROES: string = typeCreatorV2(
  'StoreReducer',
  'DeleteStore'
);
